import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Emit, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DropdownComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.isFocused = false;
  }
  changed(target) {
    if (target.value === "") {
      return target.value;
    }
    target.blur();
    return this.options[+target.value].value;
  }
  setFocused(isFocused) {
    this.isFocused = isFocused;
  }
  get hasValue() {
    return this.value && (this.options || []).some((option) => {
      return option.value === this.value;
    });
  }
  get placeholderLabel() {
    return this.hasEmptyPlaceholder ? "" : this.placeholder;
  }
  get hasEmptyPlaceholder() {
    return ["true", "", "placeholder", true].includes(this.placeholder);
  }
  get currentOption() {
    var _a;
    const selected = (_a = this.options) == null ? void 0 : _a.find((option) => {
      return option.value === this.value;
    });
    if (!selected) {
      return this.placeholderLabel;
    }
    return selected.name;
  }
};
__decorateClass([
  Prop(Boolean)
], DropdownComponent.prototype, "ellipsis", 2);
__decorateClass([
  Prop({
    validator: (options) => {
      if (!options || !Array.isArray(options)) {
        return true;
      }
      return options.every(({ name, value }) => !!name && value !== void 0);
    }
  })
], DropdownComponent.prototype, "options", 2);
__decorateClass([
  Prop()
], DropdownComponent.prototype, "value", 2);
__decorateClass([
  Prop({
    validator: (value) => {
      return typeof value === "string" || typeof value === "boolean";
    },
    default: false
  })
], DropdownComponent.prototype, "placeholder", 2);
__decorateClass([
  Prop(Boolean)
], DropdownComponent.prototype, "disabled", 2);
__decorateClass([
  Prop(Boolean)
], DropdownComponent.prototype, "light", 2);
__decorateClass([
  Prop(Boolean)
], DropdownComponent.prototype, "link", 2);
__decorateClass([
  Prop(Boolean)
], DropdownComponent.prototype, "small", 2);
__decorateClass([
  Prop(Boolean)
], DropdownComponent.prototype, "allowEmpty", 2);
__decorateClass([
  Prop(String)
], DropdownComponent.prototype, "iconPrefix", 2);
__decorateClass([
  Emit("change")
], DropdownComponent.prototype, "changed", 1);
DropdownComponent = __decorateClass([
  Component({
    name: "ui-dropdown"
  })
], DropdownComponent);

export default DropdownComponent;
